import React, { forwardRef } from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(styles);

const UncontrolledText = ({ error, label, registration, inputProps = {}, type, value, disabled=false }) => {
  const classes = useStyles();

  // const { field, label, direction, disabledOnEdit, disabled, validate } = i;
  const { readOnly } = inputProps;

  // const isDisabled = disabled || (disabledOnEdit && mode === 'EDIT');

  const InputElement = type === 'textarea' ? 'textarea' : 'input';

  return (
    <div className={cn(classes.inputContainer)}>
      {label && (
        <p
          style={{ marginBottom: 5, fontWeight: 400 }}
          className={cn(
            classes.inputLabel,
            // disabledOnEdit && mode === 'EDIT' && classes.disabledText,
            // error && classes.textLabelError,
          )}
        >
          {label}
          {/* : {!!error && error} */}
        </p>
      )}
      <InputElement
        disabled={disabled}
        type={type}
        className={cn(
          classes.input,
          classes.textInput,
          // !!error && classes.textInputError,
          readOnly && classes.disabledInput,
        )}
        style={
          {
            // height: 27, // matching the Date input height
          }
        }
        readOnly={readOnly}
        value={value}
        {...inputProps}
        {...registration}
      />
    </div>
  );
};

export default UncontrolledText;
